import React, { useEffect, useState } from 'react';
import './Navigator.css';

//Revision 20260922

function Navigator({ state, setState }) {

    const [selectedCountryName, setSelectedCountryName] = useState('');
    const [selectedDistrictName, setSelectedDistrictName] = useState('');
    const [selectedCommunityName, setSelectedCommunityName] = useState('');
    const [selectedAgreementName, setSelectedAgreementName] = useState('');
    const [selectedTypeName, setSelectedTypeName] = useState('');

    useEffect(() => {
        const countryname = state.countries.find(country => country.id == state.selectedcountry)?.name;
        setSelectedCountryName(countryname);
    }, [state.selectedcountry]);

    useEffect(() => {
        const districtname = state.menu.find(district => district.id == state.selecteddistrict)?.name;
        setSelectedDistrictName(districtname);
    }, [state.menu, state.selecteddistrict]);

    useEffect(() => {
        if (state.selecteddistrict !== null && state.selectedcommunity !== null) {
            const district = state.menu.find(district => district.id === state.selecteddistrict);
            const community = district?.communities.find(community => community.id === state.selectedcommunity);
            setSelectedCommunityName(community ? community.name : 'All communities');
        }
    }, [state.selecteddistrict, state.selectedcommunity]);

    useEffect(() => {
        const agreementname = state.agreements.find(agreement => agreement.id == state.selectedagreement)?.name || 'All agreements';
        setSelectedAgreementName(agreementname)
    }, [state.selectedagreement]);

    useEffect(() => {
        const typename = state.types.find(type => type.id == state.selectedtype)?.name || 'All types';
        setSelectedTypeName(typename)
    }, [state.selectedtype]);

    const handleCountries = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Countries state={state} setState={setState} />, modaltype: 'small', modaltitle: 'Countries' }))
    }

    const handleDistricts = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Districts state={state} setState={setState} />, modaltype: 'small', modaltitle: 'Districts' }))
    }

    const handleCommunities = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Communities state={state} setState={setState} />, modaltype: 'small', modaltitle: 'Communities' }))
    }

    const handleAgreements = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Agreements state={state} setState={setState} />, modaltype: 'small', modaltitle: 'Agreements' }))
    }

    const handleTypes = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Types state={state} setState={setState} />, modaltype: 'small', modaltitle: 'Types' }))
    }

    function Countries({ state, setState }) {
        const [search, setSearch] = useState('');

        const filteredCountries = state.countries.filter(country =>
            country.name.toLowerCase().includes(search.toLowerCase())
        );

        const handleCountry = (country) => {
            setState(prevState => ({
                ...prevState,
                selectedcountry: country.id,
                selecteddistrict: country.defaultdistrict,
                modalopen: false,
                modalcontent: null,
                modaltype: null
            }));
        };

        return (
            <div className="navigator_modal">
                <div className="navigator_inputcontainer">
                    <input
                        type="text"
                        placeholder="Search countries..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        className="navigator_input"
                    />
                </div>
                <div className="navigator_scrollable">
                    {filteredCountries.map((country, index) => (
                        <div
                            key={'country' + index}
                            className={state.selectedcountry == country.id ? 'navigator_selectoption navigator_selectoptionselected' : 'navigator_selectoption'}
                            onClick={() => handleCountry(country)}
                        >
                            {country.name} ({country.count})
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    function Districts({ state, setState }) {
        const [search, setSearch] = useState('');

        const filteredDistricts = state.menu.filter(district =>
            district.name.toLowerCase().includes(search.toLowerCase())
        );

        const handleDistrict = (district) => {
            setState(state => ({ ...state, selecteddistrict: district.id }));
            setState(state => ({ ...state, selectedcommunity: 0 }));
            let communities = district.communities;
            setState(state => ({ ...state, communities: communities }));
            setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null }));
        }

        return (
            <div className="navigator_modal">
                <div className="navigator_inputcontainer">
                    <input
                        type="text"
                        placeholder="Search districts..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        className="navigator_input"
                    />
                </div>
                <div className="navigator_scrollable">
                    {
                        filteredDistricts.map((district, index) => {
                            const totalCommunities = district.communities.reduce((total, community) => total + community.no, 0);

                            return (
                                <div key={'district' + index}
                                    className={state.selecteddistrict == district.id ? 'navigator_selectoption navigator_selectoptionselected' : 'navigator_selectoption'}
                                    onClick={() => handleDistrict(district)}
                                >
                                    {district.name} ({totalCommunities})
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }

    function Communities({ state, setState }) {
        const [search, setSearch] = useState('');

        const filteredCommunities = state.communities.filter(community =>
            community.name.toLowerCase().includes(search.toLowerCase())
        );

        const handleCommunityClick = (communityid) => {
            setState(prevState => ({
                ...prevState,
                selectedcommunity: communityid,
                modalopen: false,
                modalcontent: null,
                modaltype: null
            }));
        };

        return (
            <div className="navigator_modal">
                <div className="navigator_inputcontainer">
                    <input
                        type="text"
                        placeholder="Search communities..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        className="navigator_input"
                    />
                </div>
                <div className="navigator_scrollable">
                    <div
                        className={state.selectedcommunity == 0 ? 'navigator_selectoption navigator_selectoptionselected' : 'navigator_selectoption'}
                        onClick={() => handleCommunityClick(0)}
                    >
                        All
                    </div>
                    {filteredCommunities.map((community, index) => (
                        <div
                            key={'community' + index}
                            className={state.selectedcommunity == community.id ? 'navigator_selectoption navigator_selectoptionselected' : 'navigator_selectoption'}
                            onClick={() => handleCommunityClick(community.id)}
                        >
                            {community.name} ({community.no})
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    function Agreements({ state, setState }) {
        const [search, setSearch] = useState('');

        const filteredagreements = state.agreements.filter(agreement =>
            agreement.name.toLowerCase().includes(search.toLowerCase())
        );

        const handleAgreement = (agreementid) => {
            setState(state => ({ ...state, selectedagreement: agreementid, selectedoffset: 0, modalopen: false, modalcontent: null, modaltype: null }))
        }

        return (
            <div className="navigator_modal">
                <div className="navigator_inputcontainer">
                    <input
                        type="text"
                        placeholder="Search agreements..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        className="navigator_input"
                    />
                </div>
                <div className="navigator_scrollable">
                    <div
                        className={state.selectedagreement == 0 ? 'navigator_selectoption navigator_selectoptionselected' : 'navigator_selectoption'}
                        onClick={() => handleAgreement(0)}
                    >
                        All
                    </div>
                    {
                        filteredagreements.map((agreement, index) => {
                            return (
                                <div key={'agreement' + index}
                                    className={state.selectedagreement == agreement.id ? 'navigator_selectoption navigator_selectoptionselected' : 'navigator_selectoption'}
                                    onClick={() => handleAgreement(agreement.id)}
                                >
                                    {agreement.name}
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }


    function Types({ state, setState }) {
        const [search, setSearch] = useState('');

        const filteredTypes = state.types.filter(type =>
            type.name.toLowerCase().includes(search.toLowerCase())
        );

        const handleType = (typeid) => {
            setState(state => ({ ...state, selectedtype: typeid, selectedoffset: 0, modalopen: false, modalcontent: null, modaltype: null }))
        }

        return (
            <div className="navigator_modal">
                <div className="navigator_inputcontainer">
                    <input
                        type="text"
                        placeholder="Search types..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        className="navigator_input"
                    />
                </div>
                <div className="navigator_scrollable">
                    <div
                        className={state.selectedtype == 0 ? 'navigator_selectoption navigator_selectoptionselected' : 'navigator_selectoption'}
                        onClick={() => handleType(0)}
                    >
                        All
                    </div>
                    {
                        filteredTypes.map((type, index) => {
                            return (
                                <div key={'type' + index}
                                    className={state.selectedtype == type.id ? 'navigator_selectoption navigator_selectoptionselected' : 'navigator_selectoption'}
                                    onClick={() => handleType(type.id)}
                                >
                                    {type.name}
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }

    return (
        <div className='navigator' >
            <button className='navigator_link' onClick={() => handleCountries()}>{selectedCountryName}</button>
            <button className='navigator_link' onClick={() => handleDistricts()}>{selectedDistrictName}</button>
            <button className='navigator_link' onClick={() => handleCommunities()}>{selectedCommunityName}</button>
            <button className='navigator_link' onClick={() => handleAgreements()}>{selectedAgreementName}</button>
            <button className='navigator_link' onClick={() => handleTypes()}>{selectedTypeName}</button>
        </div>
    )
}

export default Navigator;